import { render } from "./ContributionRWD.vue?vue&type=template&id=4213bdce&scoped=true"
import script from "./ContributionRWD.vue?vue&type=script&lang=js"
export * from "./ContributionRWD.vue?vue&type=script&lang=js"

import "./ContributionRWD.vue?vue&type=style&index=0&id=4213bdce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4213bdce"]])

export default __exports__